import menu from "./menu";
export default {
  addFromMenu: "Add from menu",
  customGift: "Custom gift",
  giftName: "Gift name",
  price: "Price",
  atLeast: "At least",
  giftItems: "gift items",
  giftList: "Gift list",
  progressAutoSaved: "Progress auto-saved",
  markComplete: "Mark as complete",
  addSpecialItemSuccess: "Special item added successfully",
  addSpecialItemFailed: "Failed to add special item",
  addItemDescription:
    "Add items with price range between {{minPrice}} and {{maxPrice}} {{currency}}",
  addItemsWithSimilarPriceRanges: "Add items with similar price ranges",
  addNew: "Add new",
  addItem: "Add item",
  editItem: "Edit item",
  deleteGiftItemTitle: "Delete Gift",
  deleteGiftItemDescription:
    'By removing this gift from "{{pos_name}}", all similar gifts across other POSs will also be removed. Are you sure you want to proceed?',
  cancel: "Cancel",
  delete: "Delete",
  giftMapIncompatible:
    'The gift list for "{{pos_name}}" is incompatible with the other gift lists. Please adjust it to align with the "{{reference_pos_name}}" gift list.',
  duplicateItemPrice:
    'This price is already assigned to another gift in "{{pos_name}}". Please remove the existing gift first or add another gift with the same price in "{{reference_pos_name}}" before proceeding.',
  saveChanges: "Save Changes",
  loyaltyMapUpdated: "The loyalty map has been updated",
  addItemsToFirstPOS:
    "Please add items to the first POS list ({{pos_name}}) before adding them to other POS lists.",
  giftGroupsUpdatedSuccessfully: "Gift groups updated successfully",
  failedToUpdateGiftGroups: "Failed to update gift groups",
  atLeastThreeGiftGroupsRequired:
    "You have to add at least 3 gift groups to update the gift list",
  editGiftGroupTitle: "Edit group name",
  save: "Save changes",
  nameInEnglish: "Name in English",
  nameInArabic: "Name in Arabic",
  arabicTitleRequired: "Arabic title is required",
  englishTitleRequired: "English title is required",
  enterTitle: "Enter title",
  areYouSureYouWantToDeleteThisItem:
    "Are you sure you want to delete this gift?",
};
